const MIME_BY_EXTENSION = {
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
}

export function getAcademyDocumentType(file) {
  const mimeType = String((file && (file.type || file.mimeType)) || "").trim().toLowerCase()
  if (mimeType && mimeType !== "application/octet-stream") {
    return Object.keys(MIME_BY_EXTENSION).find((extension) => MIME_BY_EXTENSION[extension] === mimeType) || ""
  }
  const extension = String((file && (file.name || file.originalName)) || "").split(".").pop().toLowerCase()
  return Object.prototype.hasOwnProperty.call(MIME_BY_EXTENSION, extension) ? extension : ""
}

export function getAcademyDocumentAccept(area) {
  const extensions = area === "leadership" ? ["pdf", "doc", "docx"] : ["pdf"]
  return extensions.map((extension) => `${MIME_BY_EXTENSION[extension]},.${extension}`).join(",")
}

export function getAcademyDocumentIcon(file) {
  const type = getAcademyDocumentType(file)
  if (type === "pdf") return "mdi-file-pdf-box"
  if (type === "doc" || type === "docx") return "mdi-file-word-outline"
  return "mdi-file-document-outline"
}

export function getAcademyDocumentFileName(file, fallback = "dokument") {
  return (file && file.originalName) || `${fallback}.${getAcademyDocumentType(file) || "pdf"}`
}
